/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-key */
import React from 'react';
import './projectsPage.css';
import Header from '../components/header';
import Footer from '../components/footer';
import RealEstateAgent from '../components/realestateAgent';

function ProductRealEstate() {
  return (
    <div className="main">
      <Header />
      <RealEstateAgent />
      <Footer />
    </div>
  );
}

export default ProductRealEstate;
